// extracted by mini-css-extract-plugin
module.exports = {"wrapperWhoThisProfession":"WhoIsThisProfession_wrapperWhoThisProfession__UoBkG","content":"WhoIsThisProfession_content__2jKQ9","cell":"WhoIsThisProfession_cell__1R5Cm"};